import { Modal } from "react-bootstrap";
import { DatePicker, MyReactSelect, MySelect, Text, TextArea, TextEmail, TextPassword } from "../inputs/inputs";
import { useEffect, useRef, useState } from "react";
import { formatDataBeforeSend, validorSettings } from "../../helpers/GeneralHelper";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { apiError } from "../../helpers/ErrorHelper";
import { useAuth } from "../../context/AuthContext";
import { create, getOptions } from "../../models/QuickAddModel";

export const QuickAdd = ({title, modalKey, showModal, setShowModal, column, dependedColumn = null, setFields, form, setFieldOptions, isMultiple = false}) => {
  const closeModal = () => {
    setShowModal((prev) => ({ ...prev, [modalKey]: false }))
  }

  const { state } = useAuth();
  let user_data = state.user_data;

  let inputFields = [];
  for (let input of form.fields) {
    inputFields[input.name] = '';
  }

  const formatOptions = [];

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(inputFields);
  const [errors, setErrors] = useState(inputFields);
  const [options, setOptions] = useState({});

  let optionConfig = {};

  let inputs = [];
  for (let input of form.fields) {
    if (input.type == 'Text') {
      inputs.push(
        <Text column={input.name} label={input.label} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );
    } else if (input.type == 'TextEmail') {
      inputs.push(
        <TextEmail column={input.name} label={input.label} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );
    } else if (input.type == 'TextPassword') {
      inputs.push(
        <TextPassword column={input.name} label={input.label} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );
    } else if (input.type == 'TextArea') {
      inputs.push(
        <TextArea column={input.name} label={input.label} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );
    } else if (input.type == 'DatePicker') {
      inputs.push(
        <DatePicker column={input.name} label={input.label} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );

      formatOptions.push({
        type: 'react-datepicker',
        column: input.name,
      });
    } else if (input.type == 'MySelect') {
      inputs.push(
        <MySelect column={input.name} label={input.label} options={input.options} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );
    } else if (input.type == 'MyReactSelect') {
      if (typeof input.options === 'string' || input.options instanceof String) {
        optionConfig[input.name] = input.options;
        let optionSplit = input.options.split('.');

        formatOptions.push({
          type: 'react-select',
          column: input.name,
          labelColumn: optionSplit[optionSplit.length - 1]
        });
      } else if (typeof input.options == 'Object' || input.options instanceof Object) {
        setOptions((prev) => ({ ...prev, [input.name]: input.options }));
      } else {
        console.error('Options not found for select!');
      }

      inputs.push(
        <MyReactSelect column={input.name} label={input.label} options={options[input.name]} fields={values} setFields={setValues} errors={errors} required={input?.required} />
      );
    }
  }

  useEffect(() => {
      for (let input of form.fields) {
        if (optionConfig[input.name] && ! options[input.name]) {
          const [url, colValue, colLabel] = optionConfig[input.name].split('.');

          const fetchOptions = async () => {
            try {
              const result = await getOptions({user_token: user_data.user_token, url: url});
              const resultOptions = result[input.responseKey].map(item => ({
                value: item[colValue],
                label: item[colLabel]
              }));

              setOptions((prev) => ({ ...prev, [input.name]: resultOptions }));
            } catch (error) {
              console.error(error);
            }
          };

          fetchOptions();
        }
      }
  }, []);

  const validator = useRef(new SimpleReactValidator(validorSettings()));
  const submit = async(e) => {
    e.preventDefault();

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(values, inputFields, formatOptions);

      let response = await create(user_data.user_token, form.url, formData);
      if (response.status) {
        toast.success(response.message);

        let isLabelString = false;
        if (typeof form.labelCol === 'string' || form.labelCol instanceof String) {
          isLabelString = true;
        }

        if (dependedColumn) {
          setFields((prev) => ({...prev, [dependedColumn]: values[form.dependedColumn] }));
        } else {
          const options = response.data[form.responseKey].map(item => ({
            value: item[form.valueCol],
            label: isLabelString ? item[form.labelCol] : concatLabels(item, form.labelCol)
          }));

          setFieldOptions(options);
        }

        const value = {value: response.data.last_id, label: isLabelString ? values[form.labelCol] : concatLabels(values, form.labelCol)};
        if (isMultiple) {
          setFields((prev) => ({...prev, [column]: [value]}));
        } else {
          setFields((prev) => ({...prev, [column]: value}));
        }

        setValues(inputFields);
        closeModal();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);
    }

    setLoading(false);
  }
  let i = 1;

  return (
      <Modal show={showModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add {title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="pt-0">
          { inputs.map((item) => <div key={i++} className="mt-3">{item}</div> )}
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
          <button type="button" className="btn btn-success" onClick={submit} disabled={loading}>
            {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Add'}
          </button>
        </Modal.Footer>
      </Modal>
  );
};

function concatLabels(data, labels) {
  let vals = [];
  for (let label of labels) {
    vals.push(data[label]);
  }

  return vals.join(' ');
}